import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch, Action } from 'redux';
import IconButton from '../common/IconButton';
import NewToolbarItemScroller from '../common/toolbar-item-scroller/NewToolbarItemScroller';
import CurrentToolIcon from '../header-toolbar/CurrentToolIcon';
import { Level } from '../header-toolbar/NewHeaderToolbar';
import HistoryAction from '../../actions/HistoryAction';
import UIAction from '../../actions/ui/UIAction';
import DrawingToolAction from '../../drawing/actions/DrawingToolAction';
import { getEditorKeyAndPage } from '../../helpers/integratedDrawings';
import { AppStates } from '../../reducers/app';
import {
  IntegratedDrawingState, getPrevDrawingPage, canUndoDrawing, canRedoDrawing, getNextDrawingPage,
} from '../../reducers/integratedDrawing';
import { PagesState } from '../../reducers/pages';
import { CurrentTool } from '../../reducers/ui/ui';
import { Publication } from '../../types/epub';
import { PageAction } from '../../../../..';

interface HeaderToolbarImagePastingLevelProps {
  readonly isVertical: boolean;
  readonly pages: PagesState;
  readonly publication?: Publication;
  readonly integratedDrawing: IntegratedDrawingState;
  readonly pushLevel: (level: Level) => void;
  readonly popToTopLevel: () => void;
  readonly dispatch: Dispatch<Action>;
}

class HeaderToolbarImagePastingLevel extends React.PureComponent<
  HeaderToolbarImagePastingLevelProps
> {
  private imageFileInput: HTMLInputElement | null = null;

  private handleChangeImageFile = () => {
    let selectedFile;

    if (this.imageFileInput === null) {
      selectedFile = null;
    } else {
      const { files } = this.imageFileInput;
      if (files === null || files.length === 0) {
        selectedFile = null;
      } else {
        selectedFile = files[0];
      }
    }
    this.props.dispatch(DrawingToolAction.setImageToPaste(selectedFile));
  }

  private handleUndo = () => {
    const { pages, publication, integratedDrawing, dispatch } = this.props;
    if (publication === undefined) {
      return;
    }

    const index = getEditorKeyAndPage(pages, publication);
    const page = getPrevDrawingPage(integratedDrawing, index);
    dispatch(HistoryAction.undo());

    if (page !== null) {
      PageAction.moveToPage(pages.activeTab, page, dispatch);
    }
  }

  private handleRedoDrawing = () => {
    const { pages, publication, integratedDrawing, dispatch } = this.props;
    if (publication === undefined) {
      return;
    }

    const index = getEditorKeyAndPage(pages, publication);
    const page = getNextDrawingPage(integratedDrawing, index);
    dispatch(HistoryAction.redo());

    if (page !== null) {
      PageAction.moveToPage(pages.activeTab, page, dispatch);
    }
  }

  public render() {
    const {
      isVertical,
      integratedDrawing,
      pages,
      publication,
      pushLevel,
      popToTopLevel,
      dispatch,
    } = this.props;

    const canUndo = publication !== undefined
      ? canUndoDrawing(integratedDrawing, getEditorKeyAndPage(pages, publication))
      : false;

    const canRedo = publication !== undefined
      ? canRedoDrawing(integratedDrawing, getEditorKeyAndPage(pages, publication))
      : false;

    return <>
      <CurrentToolIcon />

      <NewToolbarItemScroller vertical={isVertical} alignEnd={false} scrollButtons={true}>
        <IconButton
          title="画像貼り付け"
          rouondRect={true}
          imagePath="images/tool-icons/new/attachment/attachment"
          onClick={() => UIAction.setCurrentTool(CurrentTool.ImagePasting, dispatch)} />
        <label htmlFor="image-input" style={{
          fontSize: '11px',
          textAlign: 'center',
          width: '48px',
          lineHeight: '48px',
          background: 'rgba(0, 0, 0, 0.1)',
        }}>
          画像選択
          <input
            id="image-input"
            ref={el => this.imageFileInput = el}
            style={{ display: 'none' }}
            onChange={this.handleChangeImageFile}
            type="file" />
        </label>
        <IconButton
          title="ズーム/パン+紙面操作"
          imagePath="images/tool-icons/new/zoompan/zoompan"
          onClick={() => UIAction.setCurrentTool(CurrentTool.Touch, dispatch)} />
        <IconButton
          title="オブジェクト選択"
          imagePath="images/tool-icons/new/object_selection/object_selection"
          rouondRect={true}
          onClick={() => UIAction.setCurrentTool(CurrentTool.ObjectSelection, dispatch)} />
        <IconButton
          title="UNDO"
          imagePath="images/tool-icons/new/undo/undo"
          rouondRect={true}
          disabled={!canUndo}
          onClick={this.handleUndo} />
        <IconButton
          title="REDO"
          imagePath="images/tool-icons/new/redo/redo"
          rouondRect={true}
          disabled={!canRedo}
          onClick={this.handleRedoDrawing} />
        <IconButton
          title="オブジェクト消去"
          imagePath="images/tool-icons/new/eraser/eraser"
          rouondRect={true}
          onClick={() => UIAction.setCurrentTool(CurrentTool.ObjectRemoval, dispatch)}
        />
        <IconButton
          title="ゴミ箱"
          imagePath="images/tool-icons/new/trashbox/trashbox"
          rouondRect={true}
          onClick={() => {
            UIAction.setCurrentTool(CurrentTool.AllErasing, dispatch);
            pushLevel(Level.AllErasing);
          }} />
      </NewToolbarItemScroller>

      <IconButton
        title="戻る"
        rouondRect={true}
        imagePath="images/tool-icons/new/btn_top/btn_top"
        onClick={popToTopLevel} />
    </>;
  }
}

const mapStateToProps = (appStates: AppStates) => {
  const { pages, publication, integratedDrawing } = appStates;
  return { pages, publication, integratedDrawing };
};

export default connect(mapStateToProps)(HeaderToolbarImagePastingLevel);
